import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Step } from '../../utilities/payment-step';
import { AddressService } from '../../services/address.service';
import {
  Order,
  PaymentEntity,
  PaymentStepperNewEvent,
  PaymentTransportationMethod,
  Voucher,
} from 'src/app/shared';
import { Address, PaymentStatusPreSubmit, PAYMENT_COMPS } from 'src/app/core';

@Component({
  selector: 'payment-transportation',
  templateUrl: './transportation.component.html',
  styleUrls: ['./transportation.component.sass'],
})
export class TransportationComponent
  extends Step<PaymentStepperNewEvent>
  implements OnInit
{
  // -------------------------------Two way bindings|

  @Input('transportationMethod')
  transportationMethod!: any;

  @Output('transportationMethodChange')
  transportationMethodChange: EventEmitter<PaymentTransportationMethod> =
    new EventEmitter();

  @Input('address') address!: Address;
  @Output('addressChange') addressChange: EventEmitter<Address> =
    new EventEmitter();

  @Input() orders!: Order[];

  // --------------------------------Inputs|

  @Input() transportationMethods!: PaymentTransportationMethod[];
  @Input('payment') payment!: PaymentEntity;

  // --------------------------------Outputs|

  @Output('stepper') stepperEvent: EventEmitter<PaymentStepperNewEvent> =
    new EventEmitter();

  // --------------------------------Properties|

  public loading: boolean = true;
  public selectedAddress!: Address;
  public voucherCode!: Voucher;

  // --------------------------------Public getters and setters|

  public get readyForNextLevel(): boolean {
    return !!this.address && !!this.transportationMethod;
  }

  public get selectedTransportationMethodObject(): PaymentTransportationMethod {
    return this.transportationMethods[0];
  }

  // --------------------------------------------Constructors|

  constructor(private addressService: AddressService) {
    super(PAYMENT_COMPS.TRANSPORTATION);
  }

  ngOnInit(): void {}

  // --------------------------------------------Public methods|

  previous(): void {
    this.stepperEvent.next(this.getEvent('previous'));
  }

  next(): void {
    this.stepperEvent.next(this.getEvent('next'));
  }

  init(): void {
    this.stepperEvent.next(this.getEvent('init'));
  }

  /**
   * Update and upload database to ignore.
   */
  public radioButtonChange(event: any) {
    this.transportationMethodChange.emit(event.value);
  }

  public generateStatus(): PaymentStatusPreSubmit {
    return {
      price: (() => {
        const selectedOrders = this.orders.filter((item) => item.selected);
        const selectedOrdersLen = selectedOrders.length;
        let price = 0;

        if (selectedOrdersLen === 0) {
          return 0;
        }

        for (let order of selectedOrders) {
          price = price + parseInt(order.price || '0');
        }

        return price;
      })(),
      selectedCount: this.orders.filter((item) => {
        return item?.selected;
      }).length,
    };
  }

  public onAddressSelect(address: Address) {
    this.selectedAddress = address;
    this.addressChange.emit(address);
  }

  public selectTransportationMethod(method: PaymentTransportationMethod) {
    this.transportationMethodChange.emit(method);
  }

  public addNewAddress() {
    this.addressService.openAddressAddDialogBox();
  }

  public isSelected(method: PaymentTransportationMethod): boolean {
    return this?.transportationMethod?.name == method.name;
  }

  public submit() {
    const event = this.generateEvent('finalize', this.payment);
    this.stepperEvent.emit(event);
  }

  // --------------------------------------------Private methods|
  private getEvent(
    name: PaymentStepperNewEvent['name']
  ): PaymentStepperNewEvent {
    return this.generateEvent(name, this.name);
  }
}
